import React from 'react';
import { Navbar } from 'react-bootstrap';

import AppContext from '../App.context';
import ConstUtils from '../../config/constants';

import '../../style/header.css';
import utils from '../../config/utils';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: "HOME",
    };
  }

  render() {
    const entityDetails = this.context.entityDetails;

    const InsurerId = entityDetails?.insurerId;
    const InsurerName = entityDetails?.insurerName;

    const InsurerLogo = ConstUtils.InsurerLogoMapping[InsurerId];

    return (
      <Navbar bg="light" variant="light" expand="lg" fixed="top" className="bg-body-tertiary header">
        <div className="content">
          <img src={`${ConstUtils.StaticS3ImageUrl}/MedibuddyLogo.svg`} alt="Medibuddy Self Allocation"/>
          {
            (InsurerLogo || InsurerName) &&
            <>
              <img style={{ height: '25px' }} src={`${ConstUtils.StaticS3ImageUrl}/AddIcon.svg`} alt="Medibuddy Self Allocation"/>
              {
                InsurerLogo ?
                  <img src={InsurerLogo} alt="Medibuddy Self Allocation" /> : 
                  <span className='insurer-name'>{InsurerName}</span>
              }
            </>
          }
        </div>
      </Navbar>
    );
  }
}

Header.contextType = AppContext;

export default Header;
